import { SOCKET_EVENTS } from "./socketEvents";

export const registerSocketListeners = (socket, handlers = {}) => {
  if (!socket) return;

  socket.on(SOCKET_EVENTS.CONNECTED, (data) => {
    console.log("✅ SERVER CONNECTED:", data);

    handlers.onConnected?.(data);
  });

  socket.on(SOCKET_EVENTS.GAME_STATE, (data) => {
    console.log("🎮 GAME STATE:", data);
    handlers.onGameState?.(data);
  });

  socket.on(SOCKET_EVENTS.AVIATOR_ROUND_CREATED, (data) => {
    console.log("🆕 ROUND CREATED:", data);

    handlers.onRoundCreated?.(data);
  });

  socket.on(SOCKET_EVENTS.AVIATOR_BETTING, (data) => {
    console.log("💰 BETTING:", data);

    handlers.onBetting?.(data);
  });

  socket.on(SOCKET_EVENTS.AVIATOR_FLIGHT_STARTED, (data) => {
    console.log("✈️ FLIGHT STARTED:", data);

    handlers.onFlightStarted?.(data);
  });

  socket.on(SOCKET_EVENTS.AVIATOR_MULTIPLIER, (data) => {
    handlers.onMultiplier?.(data);
  });

  socket.on(SOCKET_EVENTS.AVIATOR_CRASH, (data) => {
    console.log("💥 CRASH:", data);

    handlers.onCrash?.(data);
  });

  socket.on(SOCKET_EVENTS.AVIATOR_SETTLED, (data) => {
    console.log("✅ SETTLED:", data);

    handlers.onSettled?.(data);
  });

  socket.on(SOCKET_EVENTS.AVIATOR_BET_PLACED, (data) => {
    console.log("🎯 BET PLACED:", data);

    handlers.onBetPlaced?.(data);
  });

  socket.on(SOCKET_EVENTS.AVIATOR_CASHOUT, (data) => {
    console.log("💵 CASHOUT:", data);

    handlers.onCashout?.(data);
  });

  socket.on(SOCKET_EVENTS.WALLET_UPDATED, (data) => {
    console.log("💰 WALLET UPDATED:", data);

    handlers.onWalletUpdated?.(data);
  });

  socket.on(SOCKET_EVENTS.ERROR, (data) => {
    console.error("❌ SOCKET ERROR:", data);

    handlers.onError?.(data);
  });
};

export const removeSocketListeners = (socket) => {
  if (!socket) return;

  Object.values(SOCKET_EVENTS).forEach((event) => {
    socket.off(event);
  });
};
